export default {
  intro: {
    default: 'Introduceți detaliile persoanei care semnează contractul.',
    gbr: 'Introduceți detaliile partenerului care semnează contractul.',
    gmbh: 'Introduceți detaliile proprietarului sau administratorului care semnează contractul.',
  },
  sections: {
    home_address: 'Adresă de domiciliu',
    home_address_help: 'Unde locuiește această persoană, nu adresa restaurantului.',
  },
  form: {
    owner_first_name: {
      label: 'Prenume',
      placeholder: 'Introduceți prenumele',
    },
    owner_last_name: {
      label: 'Nume',
      placeholder: 'Introduceți numele',
    },
    owner_dob: {
      label: 'Data nașterii',
      placeholder: 'Dată',
    },
    owner_phone_number: {
      label: 'Telefon',
    },
    owner_email: {
      label: 'Email',
      placeholder: 'Introduceți emailul',
      help: 'Acesta poate fi diferit de emailul cu care vă conectați.',
    },
    owner_id_number: {
      label: 'Număr de identificare (ex. CNP în SUA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Înapoi',
    next: 'Următorul',
  },
};
